import React, { useState, useEffect } from 'react'
import { useAppData } from '../../context/AppDataContext'


import { Dialog, DialogContent, DialogTitle, IconButton, Menu, Tooltip } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function DefaultClinicComponent() {

    const {associatedClinicList,defaultClinic,setDefaultClinic} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);

    const setupDefaultClinic = () =>{
        if(defaultClinic == null && associatedClinicList && associatedClinicList.length == 1){
            setDefaultClinic(associatedClinicList[0])
        } else {
            if(defaultClinic == null && associatedClinicList && associatedClinicList.length >1){
                setDialogStatus(true);
            }
        }
    }

    const updateClinic =(clinic) =>{
        setDefaultClinic(clinic);
        setDialogStatus(false);
    }

    useEffect(()=>{
        setupDefaultClinic()
    },[associatedClinicList,defaultClinic])

    return (
        <>
            {defaultClinic && defaultClinic !== null &&
                <div className='input-group'>
                    <span className='text-white' style={{fontSize:24}}>{defaultClinic.title}</span>
                    
                    <span>
                       <Tooltip title="Change">
                            <IconButton onClick={()=>setDialogStatus(true)} ><ArrowDropDown className='text-white' /></IconButton>
                       </Tooltip>
                    </span>
                    
                </div>
            }
            {associatedClinicList &&
            <Dialog
                open={dialogStatus}
                
                
                maxWidth="md"
            >
                <DialogTitle>Select Clinic</DialogTitle>
                <DialogContent>
                    <div className='table table-striped'>
                        <tbody>
                            {associatedClinicList.map(clinic=>
                                <tr  onClick={()=>updateClinic(clinic)} >
                                    <td>{clinic.title}</td>
                                    <td>{clinic.details}</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={2}>
                                    <Link to={"/profile/associated-clinic"} className='btn btn-success' > Join / Setup New</Link>
                                </td>
                            </tr>
                        </tfoot>
                    </div>
                </DialogContent>
            </Dialog>
            }
        </>

      
    )
}

export default DefaultClinicComponent